import React from "react";
import ReactDOM from "react-dom";
import App from "./core/components/App";
import "./style/index.scss"

ReactDOM.render(<App />, document.getElementById("lytiko"));